import { create } from "zustand";

export const useCheckoutStore = create((set) => ({
  consecutive: null,
  selectedSeats: [],
  payBrands: [],
  bookingDetails: {
    payType: null,
    paymentMethod: null,
    showtimeLoading: false,
    showtime: null,
    movie: null,
    prices: [],
    room: {},
    room_status: [],
    reservation: null,
    confectioneryCombos: [],
    date: null,
    hour: null,
    location: null,
    subtotal: 0,
    totalTickets: 0,
    totalConfectionery: 0,
    totalService: 0,
    total: 0,
    otherPrice: 0,
  },
  confectioneries: {},
  confectioneries_api: {},

  setConfectioneries: (confectioneries) => set({ confectioneries }),

  setConfectioneriesApi: (confectioneries_api) => set({ confectioneries_api }),

  setConsecutive: (consecutive) => set({ consecutive }),

  setPayOption: (payBrands) => set({ payBrands }),

  setSelectedSeats: (seats) => set(() => ({ selectedSeats: seats })),

  addSeat: (seat) =>
    set((state) => ({ selectedSeats: [...state.selectedSeats, seat] })),

  removeSeat: (seat) =>
    set((state) => ({
      selectedSeats: state.selectedSeats.filter(
        (selectedSeat) => selectedSeat !== seat
      ),
    })),

  clearSeats: () => set({ selectedSeats: [] }),
  setBookingDetails: (details) =>
    set((state) => ({
      bookingDetails: { ...state.bookingDetails, ...details },
    })),
  clearBookingDetails: () => set({ bookingDetails: {} }),

  addConfectioneryCombo: (product) =>
    set((state) => {
      const currentCombos = state.bookingDetails.confectioneryCombos || [];
      // Se busca un combo que coincida tanto en Codigo como en Receta
      const existing = currentCombos.find(
        (item) =>
          item.Codigo === product.Codigo && item.Receta === product.Receta
      );
      if (existing) {
        const updatedCombos = currentCombos.map((item) =>
          item.Codigo === product.Codigo && item.Receta === product.Receta
            ? {
                ...item,
                Cantidad: item.Cantidad + product.Cantidad,
              }
            : item
        );
        return {
          bookingDetails: {
            ...state.bookingDetails,
            confectioneryCombos: updatedCombos,
          },
        };
      } else {
        return {
          bookingDetails: {
            ...state.bookingDetails,
            confectioneryCombos: [...currentCombos, product],
          },
        };
      }
    }),

  updateConfectioneryCombo: (product) =>
    set((state) => {
      const currentCombos = state.bookingDetails.confectioneryCombos || [];
      const updatedCombos = currentCombos.map((item) =>
        item.Codigo === product.Codigo ? { ...item, ...product } : item
      );
      return {
        bookingDetails: {
          ...state.bookingDetails,
          confectioneryCombos: updatedCombos,
        },
      };
    }),

  removeConfectioneryCombo: (product) =>
    set((state) => {
      const currentCombos = state.bookingDetails.confectioneryCombos || [];
      const updatedCombos = currentCombos.filter(
        (item) =>
          !(item.Codigo === product.Codigo && item.Receta === product.Receta)
      );
      return {
        bookingDetails: {
          ...state.bookingDetails,
          confectioneryCombos: updatedCombos,
        },
      };
    }),

  resetCheckout: () =>
    set({
      selectedSeats: [],
      bookingDetails: {
        paymentMethod: null,
        prices: [],
        room: {},
        room_status: [],
        reservation: null,
        confectioneryCombos: [],
        date: null,
        hour: null,
        location: null,
        totalTickets: 0,
        totalConfectionery: 0,
        totalTransaction: 0,
        total: 0,
        otherPrice: 0,
      },
      confectioneries: {},
      confectioneries_api: {},
    }),

  resetCheckoutStore: () =>
    set({
      consecutive: null,
      selectedSeats: [],
      payBrands: [],
      bookingDetails: {
        showtime: null,
        movie: null,
        prices: [],
        room: {},
        room_status: [],
        reservation: null,
        date: null,
        hour: null,
        location: null,
        totalTickets: 0,
        totalConfectionery: 0,
        totalTransaction: 0,
        total: 0,
        otherPrice: 0,
      },
      confectioneries: {},
      confectioneries_api: {},
    }),
}));
